import { useState } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { IconChevronDown, IconScaleOutline } from "@tabler/icons-react";
import useDialog from "../dialogs/use_dialog";
import { InputGroup, PrimaryButton, DangerButton, Select } from "#common";
import { post } from "#api";

function AddItem({ animal }) {
  const dialog = useDialog();

  return (
    <div className="w-full flex items-center justify-end my-1">
      <Menu as="div" className="relative inline-block">
        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
          Add
          <IconChevronDown
            aria-hidden="true"
            className="-mr-1 size-5 text-gray-400 dark:text-gray-500"
          />
        </MenuButton>

        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg outline-1 outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in dark:divide-white/10 dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10"
        >
          <div className="py-1">
            <MenuItem>
              <button
                onClick={() =>
                  dialog.open(
                    <AddWeight animal={animal} close={() => dialog.close()} />,
                  )
                }
                className="group flex items-center px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden dark:text-gray-300 dark:data-focus:bg-white/5 dark:data-focus:text-white w-full"
              >
                <IconScaleOutline
                  aria-hidden="true"
                  className="mr-3 size-5 text-gray-400 group-data-focus:text-gray-500 dark:text-gray-500 dark:group-data-focus:text-white"
                />
                Add Weight
              </button>
            </MenuItem>
          </div>
        </MenuItems>
      </Menu>
    </div>
  );
}
function AddWeight({ animal, close }) {
  const [state, setState] = useState({
    weight: "",
    unit: "g",
  });
  const submit = async () => {
    const contract = {
      animalId: animal.animalId,
      notes: `${state.weight} ${state.unit}`,
      recordType: 6, // weight maybe find a better way to keep track of these
    };
    var response = await post("/animal/medicalRecord", contract);
    close();
  };
  return (
    <div className="flex flex-col gap-2">
      <div className="w-full text-center text-lg font-semibold">
        Enter Weight
      </div>
      <div className="flex items-center w-full gap-2 justify-between">
        <span>Weight: </span>
        <InputGroup
          value={state.weight}
          onChange={(e) =>
            setState({
              ...state,
              weight: e.target.value,
            })
          }
          type="number"
          className=""
        />
        <Select
          value={state.unit}
          onChange={(e) =>
            setState({
              ...state,
              unit: e.target.value,
            })
          }
          options={[
            { label: "g", key: "g" },
            { label: "lbs", key: "lbs" },
            { label: "lbs, oz", key: "lbsoz" },
          ]}
        ></Select>
      </div>
      <div className="flex items-center gap-2 justify-end">
        <DangerButton onClick={close}>cancel</DangerButton>
        <PrimaryButton onClick={submit}>submit</PrimaryButton>
      </div>
    </div>
  );
}
export default AddItem;
